import PersonIcon from '@mui/icons-material/Person';
import AdministratorsManagement from './AdministratorsManagement';


export default {
    icon: PersonIcon,
    recordRepresentation: 'reference',
    list: AdministratorsManagement
};
